import React from "react";

interface ButtonProps {
  name: string;
  isActive?: boolean;
  onClick?: () => void;
}

const Button: React.FC<ButtonProps> = ({ name, isActive, onClick }) => {
  return (
    <a
      className={`btn btn-outline-dark rounded-pill flex-none ${
        isActive ? "active" : "dotted"
      }`}
      onClick={onClick}
    >
      {name}
    </a>
  );
};

export default Button;
